/* ===== BLANCO PARDON — Product Page JavaScript ===== */

(function() {
  'use strict';

  /* ========================================= */
  /*  IMAGE GALLERY                             */
  /* ========================================= */
  function initGallery() {
    var mainImage = document.querySelector('.product-page__main-image img');
    var thumbs = document.querySelectorAll('.product-page__thumb');
    if (!mainImage || !thumbs.length) return;

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var src = thumb.getAttribute('data-image-src');
        if (!src) return;
        mainImage.src = src;
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

  /* ========================================= */
  /*  VARIANT SELECTOR                          */
  /* ========================================= */
  function initVariantSelector() {
    var form = document.querySelector('.product-form');
    if (!form) return;

    var variantInput = form.querySelector('input[name="id"]');
    var addBtn = form.querySelector('.product-info__add-btn');
    var variantData = [];

    try {
      var dataEl = document.querySelector('[data-product-variants]');
      if (dataEl) variantData = JSON.parse(dataEl.textContent);
    } catch(e) {}

    // Size buttons
    var sizeButtons = form.querySelectorAll('.product-info__size');
    sizeButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        sizeButtons.forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        updateVariant();
      });
    });

    // Color buttons
    var colorButtons = form.querySelectorAll('.product-info__color');
    colorButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        colorButtons.forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');
        // Update label
        var label = form.querySelector('.product-info__color-label');
        if (label) label.textContent = 'Color — ' + btn.getAttribute('data-color-name');
        updateVariant();
      });
    });

    function updateVariant() {
      var selectedSize = form.querySelector('.product-info__size.active');
      var selectedColor = form.querySelector('.product-info__color.active');

      if (!selectedSize) {
        addBtn.className = 'product-info__add-btn product-info__add-btn--disabled';
        addBtn.textContent = 'Select a size';
        addBtn.disabled = true;
        return;
      }

      var sizeName = selectedSize.getAttribute('data-size');
      var colorName = selectedColor ? selectedColor.getAttribute('data-color-name') : null;

      // Find matching variant
      var matched = null;
      for (var i = 0; i < variantData.length; i++) {
        var v = variantData[i];
        var matchesSize = false;
        var matchesColor = !colorName;

        for (var j = 0; j < v.options.length; j++) {
          if (v.options[j] === sizeName) matchesSize = true;
          if (colorName && v.options[j] === colorName) matchesColor = true;
        }

        if (matchesSize && matchesColor) {
          matched = v;
          break;
        }
      }

      // If only one option axis (like "One Size"), just match by title
      if (!matched && variantData.length > 0) {
        for (var k = 0; k < variantData.length; k++) {
          if (variantData[k].title === sizeName || variantData[k].option1 === sizeName) {
            matched = variantData[k];
            break;
          }
        }
      }

      // Fallback: first available variant
      if (!matched && variantData.length > 0) {
        matched = variantData[0];
      }

      if (matched) {
        variantInput.value = matched.id;
        if (matched.available) {
          addBtn.className = 'product-info__add-btn product-info__add-btn--active';
          addBtn.textContent = 'Add to cart';
          addBtn.disabled = false;
        } else {
          addBtn.className = 'product-info__add-btn product-info__add-btn--disabled';
          addBtn.textContent = 'Sold out';
          addBtn.disabled = true;
        }
      }
    }

    // Form submit — AJAX add to cart
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      if (addBtn.disabled) return;

      var variantId = variantInput.value;
      if (!variantId) return;

      addBtn.className = 'product-info__add-btn product-info__add-btn--disabled';
      addBtn.textContent = 'Adding...';
      addBtn.disabled = true;

      window.CartDrawer.addItem(parseInt(variantId), 1).then(function() {
        addBtn.className = 'product-info__add-btn product-info__add-btn--added';
        addBtn.textContent = 'Added to cart ✓';
        setTimeout(function() {
          addBtn.className = 'product-info__add-btn product-info__add-btn--active';
          addBtn.textContent = 'Add to cart';
          addBtn.disabled = false;
        }, 2000);
      });
    });
  }

  /* ========================================= */
  /*  INIT                                      */
  /* ========================================= */
  document.addEventListener('DOMContentLoaded', function() {
    initGallery();
    initVariantSelector();
  });

})();
